import { render, staticRenderFns } from "./UploadFileList.vue?vue&type=template&id=03000a87&"
import script from "./UploadFileList.vue?vue&type=script&lang=js&"
export * from "./UploadFileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports